<!-- <div mat-dialog-title class="d-flex justify-content-between align-items-center" style="margin-bottom: 0px;">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div> -->


  <div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
    <h2 class="m-0">{{ parentData.title }}</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>


  <mat-dialog-content >
    <div class="radio_group">
        <h3 class="pay_srt">Pay Type: </h3>
        <mat-radio-group [(ngModel)]="newSalarySettingData.payType">
          <mat-radio-button value="1">Hourly</mat-radio-button>
          <mat-radio-button value="2">Daily</mat-radio-button>
          <mat-radio-button value="3">Weekly</mat-radio-button>
          <mat-radio-button value="4">Monthly</mat-radio-button>
        </mat-radio-group>
      </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Pay Rate</mat-label>
        <input
          (ngModelChange)="changeRates()"
          [(ngModel)]="newSalarySettingData.payRate"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group" style="padding-top: 0px !important;margin-top: 0px;">
      <h3 class="pay_srt"> Paid On:</h3>
        <mat-radio-group [(ngModel)]="newSalarySettingData.paidOn">
          <mat-radio-button value="1">Daily</mat-radio-button>
          <mat-radio-button value="2">Weekly</mat-radio-button>
          <mat-radio-button value="3">Monthly</mat-radio-button>
        </mat-radio-group>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Gross payment</mat-label>
          <input
            (ngModelChange)="changeRates()"
            [(ngModel)]="newSalarySettingData.netPayment"
            matInput
            #input
            pattern="[0-9]+"
          />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Other Perks</mat-label>
          <input
            (ngModelChange)="changeRates()"
            [(ngModel)]="newSalarySettingData.otherPerks"
            matInput
            #input
          />
        </mat-form-field>
      </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Perks Type</mat-label>
        <input
          [(ngModel)]="newSalarySettingData.perksType"
          matInput
          #input
          
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Deduction</mat-label>
        <input
          (ngModelChange)="changeRates()"
          [(ngModel)]="newSalarySettingData.deduction"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Deduction Type</mat-label>
        <input
        [(ngModel)]="newSalarySettingData.deductionType"
        matInput
        #input
        />
      </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="outline">
          <mat-label>Net pay</mat-label>
          <input
          [readonly]="true"
            [(ngModel)]="newSalarySettingData.np"
            matInput
            #input
          />
        </mat-form-field>
      </div>
  </mat-dialog-content>
<!-- 
  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content> -->
  
  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="!newSalarySettingData.netPayment"
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  